import { Icon } from '@repo/foundations';
import { memo } from 'react';
import type { QueriedResource } from '../types';
import { getResourceIcon } from '../utils';

interface ResourceIconProps {
	resource: QueriedResource;
	className?: string;
}

export const ResourceIcon = memo(
	({ resource, className }: ResourceIconProps) => {
		const iconInfo = getResourceIcon(resource);

		return (
			<Icon
				name={iconInfo.name || 'table'}
				color="text/secondary/default"
				size="md"
				className={className}
			/>
		);
	}
);
